 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"07cdfb80","1":"18012ef3","2":"2448262d1b01365cae170ed92d557ae51358bcab","3":"5300a5aa","4":"c6a36bc3","5":"52e7c9c52fbd00b099dfbd2be4b35d6f5eaf377b","6":"b88807149f94eb0987a40d7f479bc359c5f07569","7":"9eda7e4fb34045683434fa767c48f1933e42c4ae","8":"11dd2a487fbd0b2bc4903be47570e75ed3b372ab","9":"44e50ae719093c4a9731bc529cda23195c49b06a","10":"9bd5f8fb54844a4f86cca7978771c21a5caf5ced","12":"9968412e","14":"component---toggl-src-pages-404-js","15":"component---toggl-src-pages-index-js","16":"component---toggl-src-pages-jobs-js","17":"component---toggl-src-pages-legal-js","18":"component---toggl-src-pages-mission-js","19":"component---toggl-src-pages-track-completed-signup-js","20":"component---toggl-src-pages-track-contact-js","21":"component---toggl-src-pages-track-demo-request-confirmation-js","22":"component---toggl-src-pages-track-demo-request-js","23":"component---toggl-src-pages-track-device-unsupported-js","24":"component---toggl-src-pages-track-downloads-js","25":"component---toggl-src-pages-track-features-js","26":"component---toggl-src-pages-track-forgot-password-js","27":"component---toggl-src-pages-track-index-js","28":"component---toggl-src-pages-track-integrations-js","29":"component---toggl-src-pages-track-login-js","30":"component---toggl-src-pages-track-pricing-js","31":"component---toggl-src-pages-track-sso-link-account-js","32":"component---toggl-src-pages-track-sso-login-js","33":"component---toggl-src-pages-track-sso-must-link-js","34":"component---toggl-src-pages-track-toggl-button-login-js","35":"component---toggl-src-templates-job-js","36":"component---toggl-src-templates-track-case-study-js","37":"component---toggl-src-templates-track-customer-js","38":"component---toggl-src-templates-track-invitation-js","39":"component---toggl-src-templates-track-persona-js","40":"component---toggl-src-templates-track-reset-password-js","41":"component---toggl-src-templates-track-signup-js","42":"component---toggl-src-templates-track-unsubscribe-js"}[chunkId]||chunkId) + "-" + {"0":"116fb72fa3578b9a4569","1":"db4934f9647f46f25203","2":"bf00537ba1b20fbce2d1","3":"06949b184cb00560d07e","4":"1c6ad57752d1554b9fcd","5":"d085a00347cf0336c558","6":"94b3d2cb51771632c0b2","7":"27102dfccb6a2d5f195f","8":"0e750c5c5bfe7e7a1356","9":"95344e90f7ac4cf87cb8","10":"e4581bc24674fed71b37","12":"48fd53426ae919261391","14":"4f54536df2dceb059f04","15":"f5e048049f9eff8b8e58","16":"d215042becd6d6486b82","17":"7dd749255ee7c4163c53","18":"8a2ddc594be47de03a00","19":"75bee01863b9d6f9576f","20":"52aa12be59652d939cce","21":"f49eb7dd45e328ffc642","22":"e91354dae838e6984f60","23":"22b2d5ec0c760ade2a4a","24":"5598e22dc26e468493f4","25":"4a3128e1ea06d79030b9","26":"ac45eb7cc10772f001f1","27":"552480d38cc9e06bacf7","28":"44f83289df8263d08757","29":"706a22f5fbd8c1a10bf0","30":"fb734cb68d0cf74719ad","31":"99a64072654d51bfeb83","32":"3fbc80ca385c46dc35b3","33":"c4c4f3404f5873b2fc70","34":"a3a545c245e23fc0384f","35":"4669d0f36abeb6b8b706","36":"76d81e2492eab048c40c","37":"7d9096dea996d01e96f7","38":"d19419b0158d06b1b26c","39":"12b01c02f2b597095e57","40":"2d5b3f1f4bc462179236","41":"d254ad939e12a16fd62f","42":"3ae7aa041531d196b002"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://public-assets.toggl.com/a/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
